import React, { Component } from 'react';
import {Link} from 'react-router-dom';

const TASK_MAP = {
    '1':'章节',
    '2':'试卷',
    '3':'专辑',
    '4':'口算',
}
const allTackTitle= [
    {//审核中
        title: '任务ID',
        dataIndex: 'task_id',
        key: 'task_id',
        width:80,
        fixed: 'left'
    },{
        title: '任务名',
        dataIndex: 'name',
        key: 'name',
        width:240,
        render: (text,record) => {
            return <Link to={`/questionbox/detail/${record.task_id}`}>{text}</Link>;
        }
    },{
        title: '任务名',
        dataIndex: 'name',
        key: 'name',
        width:240,
    }, {
        title: '题库类型',
        width:80,
        render: (text,record) => {
            return <span>{TASK_MAP[record.type]}</span>;
        }
    },{
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        width:80,
    },{
        title: '录入提交/录入截止',
        dataIndex: 'input_end_time',
        key: 'input_end_time',
        width:240,
    },{
        title: '录入人',
        dataIndex: 'clerk',
        key: 'clerk',
        width:120,
    },{
        title: '已录入/合格/返工',
        dataIndex: 'statics',
        key: 'statics',
        width:160,
    }, {
        title: '任务分配时间',
        dataIndex: 'assign_entry_time',
        key: 'assign_entry_time',
        width:140,
    }, {
        title: '任务分配时间',
        dataIndex: 'assign_check_time',
        key: 'assign_check_time',
        width:140,
    },{
        title: '创建人',
        dataIndex: 'create_user_name',
        key: 'create_user_name',
        width:120,
    },{
        title: '创建时间',
        dataIndex: 'create_time',
        key: 'create_time',
        width:140,
    },
    {
        title: '审核轮次',
        dataIndex: 'check_num',
        key: 'check_num',
        width:120,
        render: (text,record) => {
            return <span>{record.check_num}/{record.check_total_num}</span>;
        }
    },  {
        title: '审核人',
        dataIndex: 'verifier',
        key: 'verifier',
        width:80,
        render: (text,record) => {
            let arr = []
            if(record.verifier){
                arr = record.verifier.split(',')
            }

            return <span>
                {
                    arr.map((verifier, index)=>
                        <div key={index}>
                            {verifier}
                        </div>
                    )
                }

                </span>;
        }
    },{
        title: '返工时间',
        dataIndex: 'rework_submit_time',
        key: 'rework_submit_time',
        width:140,
    },{
        title: '审核时间/审核截止',
        dataIndex: 'check_finish_time/deadline',
        key: 'check_finish_time/deadline',
        width:140,
        render: (text,record) => {
            return <span>{record.check_finish_time}/{record.deadline}</span>;
        }
    }, {
        title: '入库时间',
        dataIndex: 'online_time',
        key: 'online_time',
        width:140,
    },{
        title: '操作',
        dataIndex: 'options',
        key: 'options',
        render: (text, record) => {
            let result = ''
            if(record.resource_url){
                result =  <span>
            <Link to={`${record.resource_url}`}>查看资源</Link>
            </span>
            }
            return result
        }
    },
]



const getFilterColumns=(role_qbox,type)=>{
    if(!role_qbox){
        return [];
    }
    let r = []
    switch (type){
        case 'pre_assign':
            r = role_qbox.columns[0]
            break;
        case 'entrying':
            r = role_qbox.columns[1]
            break;
        case 'pre_check':
            r = role_qbox.columns[2]
            break;
        case 'checking':
            r = role_qbox.columns[3]
            break;
        case 'rework':
            r = role_qbox.columns[4]

            break;
        case 'check_pass':
            r = role_qbox.columns[5]

            break;
        case 'online_ing':
            r = role_qbox.columns[6]

            break;
        case 'online_fail':
            r = role_qbox.columns[7]

            break;
        case 'online_success':
            r = role_qbox.columns[8]

            break;
        default:
            break;
    }
    //判断按钮是否显示
    let arr=[]
    allTackTitle.forEach((d,i)=>{
        if(r[i]){
            arr.push(d)
        }
    })
    return arr
}

export {getFilterColumns}


// WEBPACK FOOTER //
// ./src/entry_app/question_box/mission_list/columns.js